<template>
  <div class="cs-root cs-embed">
    <component :is="view" v-if="view" />
  </div>
</template>

<script>
// 客服业务页在后台管理里的宿主：把客服工作台（/cs/*）的页面组件原样内嵌到后台内容区。
//
// 为什么能直接复用组件、不需要 iframe：
//   客服页面组件本身不含布局壳（侧边栏/顶栏在 CsLayout 里），页面样式全部收在 .cs-root 作用域下，
//   所以这里只要给一个 .cs-root 容器，外观就与客服工作台一致，又不会污染后台主题；
//   而这些页面本来就依赖 element-ui 默认样式，后台主题与之同源，两边天然兼容。
//
// 为什么用 meta.csView 而不是一页一个包装组件：
//   客服后续新增业务页时，只要在 features/admin/router.js 加一条路由（meta 里带上页面组件）、
//   在 AdminLayout 的「客服管理」菜单里加一项即可，本宿主不用再改。
export default {
  name: 'AdminCustomerServiceHost',
  computed: {
    view () {
      return (this.$route.meta && this.$route.meta.csView) || null
    }
  }
}
</script>

<style lang="scss">
@import '../../customerService/styles/cs-theme.scss';

// 覆盖 .cs-root 的整页壳约束：内嵌到后台内容区时，尺寸与滚动交给 .wrapper-content，
// 背景也跟随后台（透明），避免一块浅灰底把后台内容区切成两层
.cs-root.cs-embed {
  height: auto;
  min-height: 0;
  overflow: visible;
  background: transparent;
  padding: 0;
}
</style>
